import React from 'react'
import BottomLeftMenu from "../components/addons/bottom_left_menu";
import EventCountdown from "../components/addons/event_countdown";
import Navigation from '../components/navigation'
import NavigationEn2022 from '../components/addons/navigation_en_2022'
import NavigationDe2022 from '../components/addons/navigation_de_2022'
export default function AddonRenderer({imageMap, ...props}) {

  const componentMap = {
    bottom_left_menu: BottomLeftMenu,
    // event_countdown: EventCountdown,
    navigation: Navigation,
    navigation_en_2022: NavigationEn2022,
    navigation_de_2022: NavigationDe2022
  }

  const getSortedAddons = (addons) => {
    return _.sortBy(addons, function(element){
      let defaultSort = 0
      let rank = {
      };

      return rank[element] || defaultSort;
    });
  }


  return <>
    {imageMap && imageMap.addons && getSortedAddons(imageMap.addons).map((addon) => {
      // react requires big letters for react classes
      // https://reactjs.org/docs/jsx-in-depth.html#choosing-the-type-at-runtime
        const DynamicComponent = componentMap[addon]
        if(DynamicComponent)
          return <DynamicComponent key={"addon" + addon} imageMap={imageMap} imageMapAddons={imageMap.addons}/>
    })}
  </>
}
